/**
 * Formatadores PT-BR pra UI do atendimento.
 */

export function relativeTime(iso: string): string {
  const nowDate = new Date();
  const msgDate = new Date(iso);
  const diff = Math.max(0, nowDate.getTime() - msgDate.getTime());
  const min = Math.floor(diff / 60_000);
  if (min < 1) return 'agora';
  if (min < 60) return `há ${min}min`;
  const hr = Math.floor(min / 60);
  if (hr < 24) return `há ${hr}h`;
  // Pra "ontem" e dias: compara DATAS DE CALENDÁRIO local, não janela de 24h.
  // Ex: msg de 27/05 às 18h, agora é 29/05 às 10h → 40h ≠ "ontem" (é anteontem).
  // Math.floor(40/24)=1 estava reportando "ontem" errado. Cálculo correto:
  // diferença entre meia-noites locais.
  const today = new Date(nowDate.getFullYear(), nowDate.getMonth(), nowDate.getDate());
  const msgDay = new Date(msgDate.getFullYear(), msgDate.getMonth(), msgDate.getDate());
  const dayDiff = Math.floor((today.getTime() - msgDay.getTime()) / 86_400_000);
  if (dayDiff <= 1) return 'ontem';
  if (dayDiff < 7) return `há ${dayDiff}d`;
  return msgDate.toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit' });
}

export function dayLabel(iso: string): string {
  const d = new Date(iso);
  const today = new Date();
  const yesterday = new Date();
  yesterday.setDate(today.getDate() - 1);
  const sameDay = (a: Date, b: Date) => a.toDateString() === b.toDateString();
  if (sameDay(d, today)) return 'Hoje';
  if (sameDay(d, yesterday)) return 'Ontem';
  return d.toLocaleDateString('pt-BR', { day: '2-digit', month: 'short', year: 'numeric' });
}

export function timeLabel(iso: string): string {
  return new Date(iso).toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });
}

export function firstName(full: string | null | undefined): string {
  if (!full) return '';
  return full.trim().split(/\s+/)[0] ?? '';
}
